import {
  catalogueSummary,
  useImportCsvMutation,
} from '@/features/imports/api/use-import-csv-mutation';
import { queryKeys } from '@/lib/query-keys';
import type {
  ImportResourcesCsvInput,
  ImportResourcesCsvResponse,
} from '@borradh-workspace/api-client/types';
import { importResourcesCsvResponseSchema } from '@borradh-workspace/contracts';

export const useImportResourcesCsv = (options?: {
  onSuccess?: (result: ImportResourcesCsvResponse) => void;
}) => {
  const { mutate, mutateAsync, isImporting } = useImportCsvMutation<
    ImportResourcesCsvInput,
    ImportResourcesCsvResponse
  >({
    path: 'resources/import-csv',
    schema: importResourcesCsvResponseSchema,
    event: 'resources_imported_csv',
    track: (r) => ({
      imported: r.imported,
      updated: r.updated,
      skipped: r.skipped,
      rowsInFile: r.rowsInFile,
      categoriesCreated: r.categoriesCreated,
    }),
    // `resources` is the root over the category list and every resource list.
    invalidate: () => [queryKeys.resources.all()],
    summarize: (r) => {
      const parts = catalogueSummary({ ...r, errors: [] });
      if (r.categoriesCreated > 0)
        parts.push(`${r.categoriesCreated} categories`);
      if (r.errors.length > 0) parts.push(`${r.errors.length} failed`);
      return parts;
    },
    onSuccess: options?.onSuccess,
  });
  return {
    importResourcesCsv: mutate,
    importResourcesCsvAsync: mutateAsync,
    isImporting,
  };
};
